import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./Header.css";

const TICKER_REFRESH_MS = 60 * 1000;

function categoryFromUrl() {
  try {
    const params = new URLSearchParams(window.location.search || "");
    return params.get("category") || "";
  } catch {
    return "";
  }
}

function formatCadPrice(value) {
  const price = Number(value);
  if (!Number.isFinite(price)) return "";
  let digits = 2;
  if (price < 1) digits = 4;
  if (price < 0.01) digits = 6;
  return `C$${price.toLocaleString("en-CA", {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  })}`;
}

const Header = () => {
  const location = useLocation();
  const [communityCategory, setCommunityCategory] = useState(() => categoryFromUrl());
  const [tickerItems, setTickerItems] = useState([]);

  useEffect(() => {
    setCommunityCategory(categoryFromUrl());
  }, [location.pathname, location.search]);

  useEffect(() => {
    const handleCommunityChanged = (event) => {
      setCommunityCategory(event?.detail?.category || "");
    };
    window.addEventListener("scoldyCommunityChanged", handleCommunityChanged);
    return () => window.removeEventListener("scoldyCommunityChanged", handleCommunityChanged);
  }, []);

  const isCommunitiesPage = location.pathname.toLowerCase().includes("communit");
  const isCryptoCommunity =
    isCommunitiesPage && communityCategory.toLowerCase() === "crypto";

  useEffect(() => {
    if (!isCryptoCommunity) return undefined;
    let cancelled = false;

    const loadTicker = async () => {
      try {
        const response = await fetch("/backend/crypto/market", {
          method: "GET",
          credentials: "include",
          headers: { Accept: "application/json" },
        });
        if (!response.ok) throw new Error(`Market data HTTP ${response.status}`);
        const payload = await response.json();
        if (!cancelled && Array.isArray(payload.items)) {
          setTickerItems(payload.items);
        }
      } catch (err) {
        console.error("Crypto ticker load error:", err);
      }
    };

    loadTicker();
    const timer = window.setInterval(loadTicker, TICKER_REFRESH_MS);
    return () => {
      cancelled = true;
      window.clearInterval(timer);
    };
  }, [isCryptoCommunity]);

  const renderTickerItems = (copyKey) =>
    tickerItems.map((item) => {
      const change = Number(item.change24h);
      const hasChange = Number.isFinite(change);
      const changeClass = !hasChange
        ? "ticker-flat"
        : change > 0
        ? "ticker-up"
        : change < 0
        ? "ticker-down"
        : "ticker-flat";
      const changeText = hasChange ? `${change > 0 ? "+" : ""}${change.toFixed(2)}%` : "";

      return (
        <span className="crypto-ticker-item" key={`${copyKey}-${item.symbol}`}>
          {item.cmcId && (
            <img
              className="crypto-ticker-icon"
              src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${item.cmcId}.png`}
              alt=""
              aria-hidden="true"
            />
          )}
          <strong>{item.symbol}</strong>
          <span className="crypto-ticker-price">{formatCadPrice(item.price)}</span>
          {changeText && <span className={changeClass}>{changeText}</span>}
          <span className="crypto-ticker-separator">•</span>
        </span>
      );
    });

  return (
    <header className="header">
      <div className="logo">
        <img src="/images/scoldy-header-icon.png" alt="Scoldy Logo" />
      </div>

      {isCryptoCommunity && (
        <div className="crypto-ticker" aria-label="Live crypto market ticker">
          <div className="crypto-ticker-label">CRYPTO MARKET</div>
          <div className="crypto-ticker-window">
            {tickerItems.length > 0 ? (
              <div className="crypto-ticker-track">
                <div className="crypto-ticker-set">{renderTickerItems("a")}</div>
                <div className="crypto-ticker-set" aria-hidden="true">
                  {renderTickerItems("b")}
                </div>
              </div>
            ) : (
              <div className="crypto-ticker-loading">Loading live market data...</div>
            )}
          </div>
        </div>
      )}

      <div className="logo">
        <img src="/images/scoldy-header-icon.png" alt="Scoldy Logo" />
      </div>
    </header>
  );
};

export default Header;
